export default function asyncTimeout(timeout: number): Promise<void> {
  return new Promise(done =>
    setTimeout(() => {
      done()
    }, timeout),
  )
}
